import loadable from "@loadable/component";
import { FC } from "react";
import { useForm, UseFormSetError } from "react-hook-form";
import { createPostSchema, IPostSchema } from "../../utils/validationSchema";
import APIS from "../../constant/Endpoint";
import usePostFormData from "../../customHooks/usePostFormData";
import { yupResolver } from "@hookform/resolvers/yup";
import { queryClient } from "../../root.component";

const CreateBlogComponent = loadable(
  (): Promise<FC> =>
    import("../../components/Posts/CreatePost") as unknown as Promise<FC>
);

const CreateBlog = () => {
  const { mutateAsync, isPostLoading } = usePostFormData<IPostSchema>({
    queryKey: ["create-posts"],
    navigateURL: "/blog/post",
  });

  const handleCreate = async (
    data: IPostSchema,
    setError: UseFormSetError<IPostSchema>
  ) => {
    const tag = data.tag.map((d) => d.value);
    const category = data.category.map((d) => d.value);
    const file = data.preview_image as File;
    delete data.preview_image;
    const url = APIS.BLOG_STATUS;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          if (!data[key]) break;
          formData.append(key, data[key]);
          break;
        default:
          if (!data[key]) break;
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    formData.append("tag", JSON.stringify(tag));
    formData.append("category", JSON.stringify(category));
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <CreateBlogComponent
      //@ts-ignore
      handleCreate={handleCreate}
      isLoading={isPostLoading}
    />
  );
};

export default CreateBlog;
